import { schema } from '@Schema/schema';
import { withDefaults } from '@Schema/utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { defaultFilter as avTableDefaultFilter } from '@components/Table/table.utils';
import { defaultFilter as customRolesDefaultFilter } from '@views/CustomRoles/utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/permissions/roles/edit/$id/')({
  validateSearch: zodValidator(withDefaults(schema.EDIT_CUSTOM_ROLES, customRolesDefaultFilter, avTableDefaultFilter)),
});
